<tpm-dialog-frame alt-theme [hasSticky]="false" [hasFooter]="false" [header]="data.heading | translate">
  <div class="inner-html-content content-md" [innerHTML]="data.content | translate : data.params | trustHtml"></div>
</tpm-dialog-frame>
